const PROFILE_CACHE_PREFIX = 'smfd-approved-member-cache-v1';

function userId(session) {
  return String(session?.user?.id || '').trim();
}

function cacheKey(session) {
  const id = userId(session);
  return id ? `${PROFILE_CACHE_PREFIX}:${id}` : '';
}

export function cacheApprovedMember(profile, session) {
  if (typeof window === 'undefined' || !profile?.approved || profile?.disabled) return;
  const key = cacheKey(session);
  if (!key) return;
  const safeProfile = {
    id: String(profile.id || '').trim(),
    email: String(profile.email || '').trim(),
    auth_email: String(session?.user?.email || '').trim(),
    full_name: String(profile.full_name || '').trim(),
    approved: true,
    disabled: false,
    is_admin: Boolean(profile.is_admin),
    restock_approver: Boolean(profile.restock_approver),
    inventory_notify: Boolean(profile.inventory_notify),
    member_kind: String(profile.member_kind || 'line_medic'),
    temporary_access_expires_at: String(profile.temporary_access_expires_at || ''),
    rems_admin_verified_at: String(profile.rems_admin_verified_at || ''),
    mobile_verified_at: String(profile.mobile_verified_at || ''),
  };
  try {
    window.localStorage?.setItem(key, JSON.stringify({ profile: safeProfile, cachedAt: new Date().toISOString() }));
  } catch (_) {
    // Offline access is best-effort when local storage is unavailable.
  }
}

export function readApprovedMemberCache(session) {
  if (typeof window === 'undefined') return null;
  const key = cacheKey(session);
  if (!key) return null;
  try {
    const payload = JSON.parse(window.localStorage?.getItem(key) || 'null');
    const profile = payload?.profile;
    const sessionEmail = String(session?.user?.email || '').trim().toLowerCase();
    const cachedAuthEmail = String(profile?.auth_email || profile?.email || '').trim().toLowerCase();
    if (!profile?.approved || profile?.disabled) return null;
    if (sessionEmail && cachedAuthEmail && sessionEmail !== cachedAuthEmail) return null;

    if (profile?.member_kind === 'rems_temporary') {
      const expiresAt = Date.parse(profile.temporary_access_expires_at || '');
      if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) return null;
    }

    return { ...profile, _offline_access: true, _offline_cached_at: String(payload?.cachedAt || '') };
  } catch (_) {
    return null;
  }
}

export function clearApprovedMemberCache(session) {
  if (typeof window === 'undefined') return;
  const key = cacheKey(session);
  if (!key) return;
  try {
    window.localStorage?.removeItem(key);
  } catch (_) {
    // Ignore storage cleanup failures.
  }
}
